import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import CustomButton from 'src/components/button/CustomButton';
import { ModalProps, useModal } from 'src/modules/modal';

const ModalFeedback: React.FC<
  ModalProps<{ title: string; message: string }>
> = ({ onClose, onResolve, title, message }) => {
  const handleOnConfirm = () => {
    onResolve();
  };

  return (
    <Modal
      onClose={onClose}
      isOpen
      isCentered
      motionPreset="slideInBottom"
      closeOnEsc={false}
      closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter justifyContent="flex-start">
          <CustomButton
            text={"Ok"}
            w={'fit-content'}
            px={10}
            bgColor={"#222"}
            textColor={"#fff"}
            onClick={handleOnConfirm}
            hoverBgColor={"#000"} 
            activeBgColor={"#000"}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const useModalFeedback = () => {
  return useModal(ModalFeedback);
};

export default useModalFeedback;
